import { styled } from '@linaria/react';
import { colors } from '@spaceshipapp/cambridge';

const { border, brandSecondary } = colors;

export const Item = styled.li`
  display: flex;
  cursor: default;

  > * {
    display: block;
    width: 100%;
    padding: 1em;
  }

  > a:hover,
  > button:hover {
    background-color: ${brandSecondary};
  }
`;

export const Profile = styled.div`
  border-bottom: 1px solid ${border};
`;

export const Description = styled.a`
  font-size: 1rem;
  color: ${colors.highlightPrimary};
`;
